export default "__VITE_ASSET__C$_yi_aN__"